//cardurile care randeaza denumirile domeniilor - Mate, DLC, DEC etc
import styled from 'styled-components'

const DomainsContainer = styled.div`
  
  .cardGroup{
    margin: 50px 40px 100px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 1px;
    grid-gap: 40px;
    justify-items: center;
    
    /*mobile versions */

    @media (max-width: 1060px) {
          grid-template-columns: repeat(2, 1fr);
      }
      
    /*mobile versions */
    @media (max-width: 720px) {
          grid-template-columns: repeat(1, 1fr);
          margin-top: 8vh;
          grid-gap: 15px;
          h2 {
            font-size: 30px;
            margin:0;
         }
      }
  }

`

export default DomainsContainer;